import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';

@Pipe({
    name: 'locTranslate',
    standalone: false
})
export class LocTranslatePipe implements PipeTransform {

    constructor(private localizationService:LocalizationService) {}

    // i dati di sostituzione vanno passati come coppie chiave/valore, non come oggetto: solo con argomenti primitivi la cache della pipe pura funziona
    public transform(value:string, ...replaceArgs:Array<any>): string {
        let _replaceData:any = null;

        if(replaceArgs.length > 0) {
            _replaceData = {}

            for(let i = 0; i < replaceArgs.length; i += 2) {
                _replaceData[replaceArgs[i]] = replaceArgs[i + 1];
            }
        }

        return this.localizationService.translate(value, _replaceData); 
    }
}

@Pipe({
    name: 'locFormat',
    standalone: false
})
export class LocFormatPipe implements PipeTransform {

    constructor(private localizationService:LocalizationService) {}

    public transform(value:string, type:string): string {
        if(this.localizationService.format[type] != null) {
            return this.localizationService.format[type](value); 
        }
    }
}

@Pipe({
    name: 'locIcon',
    standalone: false
})
export class LocIconPipe implements PipeTransform {

    constructor(private localizationService:LocalizationService) {}

    public transform(value:string, variant?:string): string {
        return this.localizationService.icon(value, variant); 
    }
}